<template>
  <div>
    <div v-if="getToken">{{ this.$router.push("/balance") }}</div>
    <div v-else>
      <div class="container-center animated fadeIn">
        <div class="text-center">
          <i class="page-header-icon">
            <p><img src="@/assets/logo.svg" class="icon-logo" /></p
          ></i>
          <h3>Let’s get your account set up</h3>
        </div>
        <div class="panel panel-filled">
          <div class="panel-body">
            <form @submit.prevent="signUp">
              <div class="row">
                <div class="form-group col-lg-12">
                  <label>{{ $t("Email") }}</label>
                  <input
                    type="email"
                    v-model="email"
                    class="form-control"
                    placeholder="Your address email to contact"
                  />
                </div>
                <div class="form-group col-lg-12">
                  <label>{{ $t("Password") }}</label>
                  <vue-password
                    v-model="password"
                    classes="form-control"
                    :user-inputs="[email]"
                  ></vue-password>
                </div>
                <div class="form-group col-lg-12">
                  <label>{{ $t("Confirm") }} {{ $t("Password") }}</label>
                  <vue-password
                    v-model="password2"
                    classes="form-control"
                    :user-inputs="[email]"
                  ></vue-password>
                  At least 6 characters,should include UPPER CASE letters and
                  numbers
                </div>
                <div class="form-group col-lg-12">
                  <p class="pointer" v-on:click="setTerms()" v-if="terms">
                    <i class="m-r-xs fad fa-check-square"></i>

                    I agree to the
                    <router-link to="/terms"
                      >365stream's Terms of Use</router-link
                    >
                  </p>
                  <p class="pointer" v-else v-on:click="setTerms()">
                    <i class="m-r-xs fad fa-square"></i>
                    I agree to the
                    <router-link to="/terms"
                      >365stream's Terms of Use</router-link
                    >
                  </p>
                </div>
              </div>
              <div class="m-b-md">
                <button
                  v-if="loading"
                  class="btn btn-default btn-block"
                  disabled=" "
                >
                  <i class="fad fa-spinner-third fa-spin m-r-xs"></i
                  >{{ $t("Loading") }}
                </button>
                <button
                  v-else-if="!email || !password || !password2"
                  class="btn btn-default btn-block"
                  disabled=" "
                >
                  {{ $t("Sign Up") }}
                </button>
                <button v-else class="btn btn-accent btn-block text-accent">
                  {{ $t("Sign Up") }}
                </button>
              </div>
              <p class="text-center">
                {{ $t("Alreadyhaveanaccount") }}?
                <router-link to="/signin">{{ $t("LogIn") }}</router-link>
              </p>
            </form>
          </div>
        </div>
        <div class="text-center" v-if="ref">Referral by {{ ref }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import nativeToast from "native-toast";
import auth from "@/api/auth";
import { mapGetters } from "vuex";
import VuePassword from "@/components/VuePassword";

export default {
  data() {
    return {
      terms: false,
      email: "",
      password: "",
      password2: "",
      loading: false,
      ref: null
    };
  },
  components: {
    VuePassword
  },
  computed: mapGetters(["getToken"]),
  methods: {
    setTerms() {
      this.terms = !this.terms;
    },
    async signUp() {
      this.loading = true;
      if (this.terms == false) {
        this.loading = false;
        nativeToast({
          message: "Please agree to the Terms of Use",
          position: "top",
          timeout: 3000,
          type: "info"
        });
      } else if (this.password != this.password2) {
        this.loading = false;
        nativeToast({
          message: "confirm password is not match",
          position: "top",
          timeout: 3000,
          type: "error"
        });
      } else if (this.password == this.password2) {
        await auth
          .signUp({
            email: this.email,
            password: this.password,
            ref: this.ref
          })
          .then(() => {
            this.loading = false;

            this.$router.push(`/emailverification/${this.email}`);
          })
          .catch(error => {
            this.loading = false;
            nativeToast({
              message: error.response.data.error,
              position: "top",
              timeout: 3000,
              type: "error"
            });
          });
      }
    }
  },
  created() {
    if (this.$route.params.ref) {
      this.ref = this.$route.params.ref;
      localStorage.setItem("Ref", JSON.stringify(this.$route.params.ref));
    }

    if (localStorage.getItem("Ref")) {
      this.ref = JSON.parse(localStorage.getItem("Ref"));
    }
  }
};
</script>
